{
  "version": 1,
  "asset_id": "8fac0287-0649-44d8-8371-f2c0181670fc",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/8fac0287-0649-44d8-8371-f2c0181670fc/esenyurt-hizli-elektrikci-7-24-dukkan-1.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/8fac0287-0649-44d8-8371-f2c0181670fc/esenyurt-hizli-elektrikci-7-24-dukkan-1.jpg",
  "original_filename": "esenyurt-hizli-elektrikci-7-24-dukkan-1.jpg",
  "size": 655683,
  "content_type": "image/jpeg",
  "created_at": "2026-09-12T10:55:58Z"
}
